import React from "react";
import { nameToSlug } from "../../../helpers";

export default function NameSection({ values, onChange }) {

	return <div className="nameSection">
		<div className="details">
			A shop has to have a name. 'Nuff said.
		</div>
		<input
			// autoFocus={true}
			placeholder="Shop name here..."
			type="text"
			value={values.name || ""}
			onChange={e => onChange({
				name: e.target.value,
				slug: nameToSlug(e.target.value)
			})}
		/>
		<br />
		<div className="details">
			If you want, you can also add a description of your shop. This will appear at the top of the shop page, as well as in the link description when the shop is found on search engines like Google.
		</div>
		<textarea
			value={values.description || ""}
			placeholder="Producers of awesome stuff at affordable prices.."
			onChange={e => onChange({
				description: e.target.value
			})}
		/>
		<br />
	</div>
}
